import React, { FC, ReactNode } from 'react';
import {
  PERFORMANCE_FEATURE_HIDE_PHASE_DEADLINE,
  PERFORMANCE_PHASE_DEADLINE_TEXT,
  PHASE_DEADLINE_DATE_PLACEHOLDER,
} from 'utils/models/PerformanceUtils';
import { getFeatureForPhase } from '../../utils/models/Campaign';
import RichTextViewer from '../Widgets/Inputs/RichTextViewer';

interface Props {
  campaign: object;
  phaseType: string;
  // phase end date, already formatted for display
  date: string;
  // default deadline sentence, shown when the admin didn't customize it
  children: ReactNode;
}

// Deadline sentence on the first page of a phase. Admins can hide it or
// replace it with their own text in the cycle's Flow & Timing settings.
const PerformancePhaseDeadline: FC<Props> = ({
  campaign,
  phaseType,
  date,
  children,
}) => {
  if (
    getFeatureForPhase(
      campaign,
      phaseType,
      PERFORMANCE_FEATURE_HIDE_PHASE_DEADLINE
    )
  ) {
    return null;
  }

  const customDeadlineText = getFeatureForPhase(
    campaign,
    phaseType,
    PERFORMANCE_PHASE_DEADLINE_TEXT
  );

  return (
    <div className="mb-4">
      {customDeadlineText ? (
        <RichTextViewer
          model={customDeadlineText.replaceAll(
            PHASE_DEADLINE_DATE_PLACEHOLDER,
            date
          )}
          expanded={true}
        />
      ) : (
        children
      )}
    </div>
  );
};

export default React.memo(PerformancePhaseDeadline);
